import { render, staticRenderFns } from "./PlayControllerAudio.vue?vue&type=template&id=2b4899ee&scoped=true"
import script from "./PlayControllerAudio.vue?vue&type=script&lang=js"
export * from "./PlayControllerAudio.vue?vue&type=script&lang=js"
import style0 from "./PlayControllerAudio.vue?vue&type=style&index=0&id=2b4899ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4899ee",
  null
  
)

export default component.exports